import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDeFlLFzldiGjSnmFZSRgIkHUBDZGWVWLU",
  authDomain: "neurerro.firebaseapp.com",
  projectId: "neurerro",
  storageBucket: "neurerro.firebasestorage.app",
  messagingSenderId: "969590144437",
  appId: "1:969590144437:web:ddb62240efc6de73beadfc"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);